import api from '@/api';

export const oilGasOccurrencesModel = {
    state: {
        data: {},
        error: false,
        loading: false,
    },
    reducers: {
        setOilGasOccurrences: (state, payload) => {
            return { ...state, data: { ...state.data, [payload.id]: payload.data } };
        },
        setError: (state, payload) => {
            return { ...state, error: payload };
        },
    },
    effects: dispatch => ({
        async loadOilGasOccurrences(wellId, rootState) {
            this.loading = true;
            try {
                const rawData = await api.carottage.fetchCoreSample({ wellIds: [wellId], type: 'saturation' });

                const res = rawData?.map(e => ({
                    id: e.id,
                    depth: e.average ? Number(e.average) : 0,
                    carbon: e.showSample ? e.showSample : 'нет данных',
                    date: e.date ? new Date(e.Date).toLocaleDateString() : 'нет данных',
                    interval:
                        e.roof && e.bottom
                            ? `${Number(e.roof).toFixed(1)} - ${Number(e.bottom).toFixed(1)}`
                            : 'нет данных',
                    description: e.lithologyDescr,
                    source: e.coreAnalysisSource ? e.coreAnalysisSource : 'нет данных',
                }));

                this.setOilGasOccurrences({ id: wellId, data: res });
                this.loading = false;
            } catch (error) {
                this.setError(error);
                this.loading = false;
                console.log(error);
            }
        },
    }),
};
